import { Switch } from "./ui/switch";
import { groupsOf } from "../lib/equipment";

export default function InventoryChecklist({ items, value, onChange }) {
  const toggle = (id) => onChange({ ...value, [id]: !value[id] });
  return (
    <div className="space-y-6">
      {groupsOf(items || []).map((group) => (
        <div
          key={group.id}
          className="bg-white border border-[#DCD8D0] rounded-xl overflow-hidden"
        >
          <div className="px-5 py-3 border-b border-[#DCD8D0] bg-[#F7F5F0]">
            <h4 className="font-semibold text-[#1A1A1A]">{group.label}</h4>
          </div>
          <ul className="divide-y divide-[#DCD8D0]">
            {group.items.map((item) => (
              <li
                key={item.id}
                className="px-5 py-3 flex items-center justify-between"
              >
                <span className="text-sm text-[#1A1A1A]">{item.label}</span>
                <Switch
                  checked={Boolean(value[item.id])}
                  onCheckedChange={() => toggle(item.id)}
                  data-testid={`inventory-${item.id}`}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
